import React, { useEffect } from 'react';
import { useAtomValue, useSetAtom } from 'jotai';
import {
  selectedConversationIdAtom
} from '../../atoms/v3/chatAtoms';
import { navigateAtom } from '../../atoms/v3/navigationAtoms';

/**
 * This component acts as a router for the base '/v3/chat' path.
 * It fetches conversations and navigates to the currently selected conversation
 * or the 'new' chat screen if no conversation is selected or no conversations exist.
 *
 * /chat 作为"回到当前选中对话"的快捷入口
 */
export const ChatRouter: React.FC = () => {
  const selectedConversationId = useAtomValue(selectedConversationIdAtom);
  const navigate = useSetAtom(navigateAtom);

  useEffect(() => {
    if (selectedConversationId) {
      navigate({ path: `/v3/chat-detail/${selectedConversationId}`, replace: true });
    } else {
      navigate({ path: '/v3/chat-detail/new', replace: true });
    }
  }, [selectedConversationId, navigate]);

  // Render loading indicator
  return (
    <div className="flex items-center justify-center h-full pt-20">
       <svg className="animate-spin h-8 w-8 text-ios-blue dark:text-ios-dark-blue" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
         <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
         <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
       </svg>
    </div>
  );
};